import { useCallback, useEffect, useState } from 'react'
import backendAPI from '../utils/backendAPI'

export const GOOGLE_REVIEWS_UPDATED_EVENT = 'klerk:google-reviews-updated'

export function notifyGoogleReviewsUpdated() {
	window.dispatchEvent(new Event(GOOGLE_REVIEWS_UPDATED_EVENT))
}

export function usePendingGoogleReviewCount(pollMs = 60000) {
	const [pendingCount, setPendingCount] = useState(0)

	const refreshPendingCount = useCallback(async () => {
		try {
			const res = await backendAPI.get('/api/dashboard/google-reviews/pending-count/')
			setPendingCount(Math.max(0, Number(res.data?.pending_count) || 0))
		} catch {
			setPendingCount(0)
		}
	}, [])

	useEffect(() => {
		refreshPendingCount()
		const intervalId = setInterval(refreshPendingCount, pollMs)
		const onUpdated = () => refreshPendingCount()
		window.addEventListener(GOOGLE_REVIEWS_UPDATED_EVENT, onUpdated)
		return () => {
			clearInterval(intervalId)
			window.removeEventListener(GOOGLE_REVIEWS_UPDATED_EVENT, onUpdated)
		}
	}, [pollMs, refreshPendingCount])

	return { pendingCount, refreshPendingCount }
}
